import { Button } from 'src/components';
import { Grid, Paper, Typography } from '@material-ui/core';
import { type RootState } from 'src/store';
import { useSelector } from 'react-redux';
import { userTypes } from 'src/helpers';
import BackIcon from '@material-ui/icons/ArrowBack';
import useStyles from './NotFound-styles';

// NOTE:
// ./src/modules/Private/Courses/Course.tsx[22:8]
function NotFound(props: any) {
	const classes = useStyles();
	const user = useSelector((state: RootState) => state.auth.data);

	return (
		<Grid
			alignItems={'center'}
			className={classes.container}
			container
			justify={'center'}
		>
			<Paper className={classes.paper}>
				<Typography variant={'h5'}> ¡Ups! </Typography>

				<Typography>
					{' '}
					Esta página no existe o no tienes permiso para acceder{' '}
				</Typography>

				<Button
					onClick={() => {
						if (user.type === userTypes.USER) {
							props.history.push('/app/courses');
						} else {
							props.history.push('/app/home');
						}
					}}
					startIcon={<BackIcon />}
				>
					Regresar
				</Button>
			</Paper>
		</Grid>
	);
}

export default NotFound;
